// extracted by mini-css-extract-plugin
export default {"subContainer":"Footer_subContainer__C3ocw","imprint":"Footer_imprint__Qp5pg","rights":"Footer_rights__976uk"};